import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const IndiaEntryPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-stone-50">
        <div className="max-w-6xl mx-auto px-6">
          <h1 className="text-5xl md:text-6xl font-bold text-[#3E2723] mb-6 border-b-2 border-dotted border-gray-300 pb-6">
            India Entry Strategy
          </h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Structured Launchpad for US Companies Expanding into India:
          </h2>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          
          {/* Services List */}
          <div className="space-y-8">
            <div className="flex items-start">
              <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Market entry & structuring advisory -
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Guidance on entity selection, regulatory positioning, and operating model aligned to business objectives.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Incorporation & Regulatory Setup -
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  End-to-end support for entity formation, registrations, and statutory readiness.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Talent & Operating model design -
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Assistance with initial hiring strategy, compensation structuring, and a scalable team setup.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Finance, Tax & Compliance framework -
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Design of accounting, tax, payroll, and reporting processes aligned with both India regulations and US oversight.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <span className="text-[#3E2723] mr-3 mt-1.5 flex-shrink-0">•</span>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Governance & ongoing support -
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Single-point coordination, compliance monitoring, and ongoing finance operations to ensure a stable transition to steady state.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-20 bg-[#3E2723] rounded-lg p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">
              Ready to expand into India?
            </h2>
            <p className="text-stone-200 mb-8 text-lg">
              Let us help you navigate the complexities of the Indian market.
            </p>
            <Button className="bg-white text-[#3E2723] hover:bg-stone-100 px-10 py-6 text-lg shadow-lg">
              Start Your India Journey
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IndiaEntryPage;
